var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avi-dialogInspectionForm"},[_c('InspectionDocumentEditor',{attrs:{"inspection":_vm.inspection}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }